export default __webpack_public_path__ + "9672f72761579622cf01b84a7eed4dd0.webp";